export default __webpack_public_path__ + "static/media/IMG_9998.a07aae0d.webp";